import { Currency } from '../../../../shared/models/currency';

export interface IssueCurrencyOption {
  id: number;
  label: string;
}

export interface IssueCurrencyPickerModel {
  label: string;
  selectedId: number | null;
  options: IssueCurrencyOption[];
}

function toId(value: number | string | null | undefined): number | null {
  const id = Number(value);
  return value !== null && value !== undefined && value !== '' && Number.isInteger(id) && id > 0 ? id : null;
}

/**
 * Builds the picker state. The default is the budget currency; when it is unknown (null or not in the
 * list) nothing is preselected, so the picker never silently defaults to a different currency.
 */
export function buildIssueCurrencyPickerModel(
  currencies: Currency[] | null | undefined,
  budgetCurrencyId: number | string | null | undefined
): IssueCurrencyPickerModel {
  const list = currencies ?? [];
  const budget = list.find((currency) => currency.id === toId(budgetCurrencyId));
  return {
    label: budget ? `Moneda del presupuesto (${budget.isoCode})` : 'Moneda del presupuesto',
    selectedId: budget ? budget.id : null,
    options: list.map((currency) => ({ id: currency.id, label: `${currency.isoCode} - ${currency.name}` })),
  };
}

/** The id to send as `issueCurrencyId`: only a chosen currency that differs from the budget currency. */
export function resolveIssueCurrencyId(
  selectedId: number | null | undefined,
  budgetCurrencyId: number | string | null | undefined
): number | undefined {
  const selected = toId(selectedId);
  return selected !== null && selected !== toId(budgetCurrencyId) ? selected : undefined;
}
